import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import _ErrorMessage from 'components/Errors/ErrorBoundary/_styles/_ErrorMessage'
import _ErrorComponentStack from 'components/Errors/ErrorBoundary/_styles/_ErrorComponentStack'
import _ErrorStack from 'components/Errors/ErrorBoundary/_styles/_ErrorStack'
import _ErrorWrapper from 'components/Errors/ErrorBoundary/_styles/_ErrorWrapper'

@withTranslation()
export default class ErrorBoundary extends Component {
  state = {
    hasError: false,
    error: false,
    info: false
  }

  render () {
    const {
      props: {
        t,
        title,
        children,
        ...other_props
      },
      state: {
        hasError,
        error: {
          message,
          stack
        },
        info: {
          componentStack
        }
      }
    } = this
    if (hasError) {
      return (
        <_ErrorWrapper {...{...other_props}}>
          <h1>{title || t('Something broke!')}</h1>
          <_ErrorMessage>
            {message}
          </_ErrorMessage>
          <_ErrorComponentStack>
            {componentStack}
          </_ErrorComponentStack>
          <_ErrorStack>
            {stack}
          </_ErrorStack>
        </_ErrorWrapper>
      )
    }
    return children
  }

  componentDidCatch (error, info) {
    this.setState({hasError: true, error, info})
  }

  static defaultProps = {
    title: null
  }
  static propTypes = {
    children: PropTypes.any.isRequired,
    title: PropTypes.string
  }
}
